import { render, staticRenderFns } from "./CreateChangelogType.vue?vue&type=template&id=116ad4f1&"
import script from "./CreateChangelogType.vue?vue&type=script&lang=ts&"
export * from "./CreateChangelogType.vue?vue&type=script&lang=ts&"
import style0 from "./CreateChangelogType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports